<app-legal-page titleKey="LEGAL.PAYMENT.TITLE" [introKey]="introKey" [sections]="sections"></app-legal-page>